import axios from 'axios';
import User from "@/module/store/user";
import {getModule} from "vuex-module-decorators";
import { LocalStorage } from 'quasar'
const userStore=getModule(User);

const requestHandler = (request:any) => {
    //console.log('%cin interceptors request=%o','color:green; font-size:14px;',request);
    if(userStore.user.isAuthenticated){
        // Modify request here
        request.headers['AXIOS-CSRFTK'] = userStore.user.csrf_token;
        request.headers['AXIOS-PTK'] = LocalStorage.getItem('token_for_permanent_session');
        request.headers['AXIOS-UID'] = userStore.user.userid;
    }else{
        console.log('%cin interceptors user is not Authenticated','color:green; font-size:20px;');
    }
    return request;
}

export default function setup() {
    axios.interceptors.request.use(
        request => requestHandler(request)
    )
}
